import { boot } from 'quasar/wrappers'
import dateUtil from '../functions/date-util'

export default boot(({ app }) => {
	app.config.globalProperties.$dateUtil = dateUtil
})
